/*
 * File: useStayAlive.js
 * Project: patient-portal
 *
 * Created by Nate Weber on 08/21/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Hook to hit keepalive endpoint every
 * 4 minutes to get a new JWT.
 */

import { useEffect, useRef } from "react";
import { keepalive } from "patient-portal-api-requests";

const keepAliveInterval = 60000 * 4;

const useStayAlive = () => {
  let timerRef = useRef();

  useEffect(() => {
    const run = () => {
      timerRef.current = setInterval(() => {
        keepalive();
      }, keepAliveInterval);
    };
    run();

    return () => {
      clearInterval(timerRef.current);
    };
  }, []);

  return null;
};

export default useStayAlive;
